module.exports = __webpack_public_path__ + "static/media/settings-inactive.f33d68a6.svg";